import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultBody from "../../Table/ResultBody";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBodyCell from "../../Table/ResultBodyCell";
import SuperText from "../SuperText";
import {useModal} from "../../../Context/ModalContext";
import StationElevationPlot from "../UI/StationElevationPlot";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultView from "../../V2/ResultView";

export function B21({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}


const fillMannTable = (arr, length) => {
    const data = new Array(length).fill([])
    arr.forEach((x, idx) => data[idx] = x)
    return data
}

const Description = ({text, row, settings, globalVariables}) => {
    const {openModal} = useModal()
    let footnotes = []

    switch (row.error_id) {
        case MessageCodes.Internal.RT05.error_id: {
            return (
                <>
                    <ResultText>
                        Horizontally varied Manning’s n value is not defined at the Bank Station at the following {row?.data?.length} cross sections.
                    </ResultText>

                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={2} style={{textAlign: 'start'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2}>Left Bank</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2}>Right Bank</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>Bank Station</ResultBodyCell>
                                <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>HvM Station</ResultBodyCell>
                                <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>Bank Station</ResultBodyCell>
                                <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>HvM Station</ResultBodyCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>{r.left_bank}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>
                                            {ResultCellHighlight(r.left_bank, r.left_station)}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>{r.right_bank}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>
                                            {ResultCellHighlight(r.right_bank, r.right_station)}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                    <EmptyLine />
                    <Footnote row={row} showLightFootnote={false} />
                </>
            )
        }
        case MessageCodes.Internal.TMANN01.error_id: {
            const max_col = Math.max(...row?.data.map(r => r.mann_table?.length || 0))
            let array = []
            try {
                array = new Array(max_col).fill(0)
            }
            catch (e) {
                array = new Array(32).fill(0)
                console.error(e)
            }

            row?.data?.forEach(r => {
                if(r.mann_table) {
                    r.mann_table = fillMannTable(r.mann_table, max_col)
                }
            })

            return (
                <>
                    <ResultText>
                        Manning’s n value within Channel is bigger than Overbank at the following {row?.data?.length || '{count}'} cross sections.
                        <EmptyLine />
                        <ResultTable data={row}>
                            <ResultHeader>
                                <ResultRow>
                                    <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'left'}}>
                                        River Station
                                    </ResultHeaderCell>
                                    {
                                        array.map((c, idx) => (
                                            <ResultHeaderCell style={{width: HecRasHelper.getWidth(5), textAlign: 'right'}}>
                                                n#{idx+1}
                                            </ResultHeaderCell>
                                        ))
                                    }
                                </ResultRow>
                            </ResultHeader>
                            <ResultBody>
                                {
                                    row?.data?.map(r => {
                                        if(r.footnote)
                                            footnotes.push(r.footnote)

                                        let hasHvM
                                        if(r?.hvm?.length > 0)
                                            hasHvM = true

                                        return (
                                            <ResultRow>
                                                <ResultHeaderCell style={{textAlign: 'left', fontWeight: 'normal'}}>
                                                    <CheckCSName
                                                        csName={(
                                                            <>
                                                                {r.cross_section} {r.footnote && <SuperText color={'red'} text={r.footnote} />}
                                                            </>
                                                        )}
                                                        csNameVal={r.cross_section}
                                                    />
                                                </ResultHeaderCell>
                                                {
                                                    r.mann_table && r.mann_table.map((m, idx) => {
                                                        let bgColor = ''
                                                        let textColor = ''

                                                        if(r.chn_indexes.includes(idx))
                                                            bgColor = '#C0FFC8'
                                                        else if(r.err_overbank_indexes.includes(idx))
                                                            textColor = 'red'

                                                        if(!m[1])
                                                            bgColor = '#ecf0f1'

                                                        return (
                                                            <ResultBodyCell style={{backgroundColor: bgColor, color: textColor, textAlign: 'right'}}>
                                                                {m[1] || ''}
                                                            </ResultBodyCell>
                                                        )
                                                    })
                                                }
                                                {
                                                    !r.mann_table && (
                                                        <>
                                                            <ResultHeaderCell>
                                                                {r.type}
                                                            </ResultHeaderCell>
                                                            {
                                                                new Array(max_col-1).fill(0).map((m, idx) => (
                                                                    <ResultBodyCell />
                                                                ))
                                                            }
                                                        </>
                                                    )
                                                }
                                            </ResultRow>
                                        )
                                    })
                                }
                            </ResultBody>
                        </ResultTable>
                    </ResultText>
                    <EmptyLine />
                    <Footnote row={row} showLightFootnote={true} />
                </>
            )
        }
        case MessageCodes.Internal.TMANN02.error_id: {
            const filteredData = row?.data;

            const max_col = Math.max(...row?.data.map(r => r.mann_table?.length || 0))
            let array = []
            try {
                array = new Array(max_col).fill(0)
            }
            catch (e) {
                array = new Array(32).fill(0)
                console.error(e)
            }

            filteredData?.forEach(r => {
                if(r.mann_table) {
                    r.mann_table = fillMannTable(r.mann_table, max_col)
                }
            })

            return (
                <>
                    <ResultText>
                        Manning’s n value is not within defined limits (Channel: {settings?.defaults?.manningsn_channel_min.toFixed(3)}-{settings?.defaults?.manningsn_channel_max.toFixed(3)}, Overbank: {settings?.defaults?.manningsn_overbank_min.toFixed(3)}-{settings?.defaults?.manningsn_overbank_max.toFixed(3)}) at the following {filteredData?.length || '{count}'} cross sections.
                        <EmptyLine />
                        <ResultTable data={row}>
                            <ResultHeader>
                                <ResultRow>
                                    <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'left'}}>
                                        River Station
                                    </ResultHeaderCell>
                                    {
                                        array?.map((c, idx) => (
                                            <ResultHeaderCell style={{width: HecRasHelper.getWidth(5), textAlign: 'right'}}>
                                                n#{idx+1}
                                            </ResultHeaderCell>
                                        ))
                                    }
                                </ResultRow>
                            </ResultHeader>
                            <ResultBody>
                                {
                                    filteredData?.map(r => (
                                        <ResultRow>
                                            <ResultHeaderCell style={{textAlign: 'left', fontWeight: 'normal'}}>
                                                <CheckCSName
                                                    csName={r.cross_section}
                                                    csNameVal={r.cross_section}
                                                />
                                                {r.footnote && <SuperText color={'red'} text={r.footnote} />}
                                            </ResultHeaderCell>
                                            {
                                                r.mann_table && r.mann_table.map((m, idx) => {
                                                    let bgColor = ''
                                                    let textColor = ''

                                                    if(r.chn_indexes.includes(idx))
                                                    {
                                                        bgColor = '#C0FFC8'
                                                        if(r.chn_error && r.chn_error_indexes.includes(idx))
                                                            textColor = 'red'
                                                    }
                                                    else if(r.chn_error_indexes.includes(idx))
                                                        textColor = 'red'
                                                    else if(r.err_overbank_indexes.includes(idx))
                                                        textColor = 'red'

                                                    if(!m[1])
                                                        bgColor = '#ecf0f1'

                                                    return (
                                                        <ResultBodyCell style={{backgroundColor: bgColor, color: textColor, textAlign: 'right'}}>
                                                            {m[1] || ''}
                                                        </ResultBodyCell>
                                                    )
                                                })
                                            }
                                            {
                                                !r.mann_table && (
                                                    <>
                                                        <ResultHeaderCell>
                                                            {r.type}
                                                        </ResultHeaderCell>
                                                        {
                                                            new Array(max_col-1).fill(0).map((m, idx) => (
                                                                <ResultBodyCell />
                                                            ))
                                                        }
                                                    </>
                                                )
                                            }
                                        </ResultRow>
                                    ))
                                }
                            </ResultBody>
                        </ResultTable>
                    </ResultText>
                    <EmptyLine/>
                    <Footnote row={row} showLightFootnote={true} />
                </>
            )
        }
    }
}

const Footnote = ({row, showLightFootnote}) => {
    return (
        <ResultText>
            {showLightFootnote && `Channel n values have a light green background.`}
            <EmptyLine />
            {
                row?.footnotes?.map(f => {
                    if(f === 1)
                    {
                        return (
                            <ResultText>
                                <EmptyLine />
                                <SuperText text={f} color={'red'} /> Manning’s n value is not defined at the Left Bank.
                            </ResultText>
                        )
                    }
                    else if(f === 2)
                    {
                        return (
                            <ResultText>
                                <EmptyLine />
                                <SuperText text={f} color={'red'} /> Left horizontally varying n station value in the geometry file do not coincide with any station in the cross section station elevation data, therefore it is assigned to the next available station.
                            </ResultText>
                        )
                    }
                })
            }
        </ResultText>
    )
}